
import { useState, useEffect } from 'react';

export const useSelector = (open) => {
    const [selected, setSelected] = useState("");

    const onHandleChange = (e) => {
        setSelected(e.target.value)
    }

    useEffect(() => {
        if(open){
            setSelected(null)
        }

    },[open])

    
    return { onHandleChange, selected };
};
